import { library } from "@fortawesome/fontawesome-svg-core";
import * as Duotone from "@fortawesome/pro-duotone-svg-icons";
import * as Regular from "@fortawesome/pro-regular-svg-icons";

// import * as Light from "@fortawesome/pro-light-svg-icons";
// import * as Solid from "@fortawesome/pro-solid-svg-icons";

class IconProvider {
   load = () => {
      library.add(
         Duotone.faCheckSquare,
         Duotone.faHome,
         Duotone.faInfoSquare,
         Duotone.faBook,
         Duotone.faUserFriends,
         Duotone.faBoxes,
         Duotone.faCars,
         Duotone.faSirenOn,
         Duotone.faEdit,
         Duotone.faFolderPlus,
         Duotone.faUsers,
         Duotone.faTrash,
         Duotone.faExclamationTriangle,
         Duotone.faBars,
         Regular.faCircle,
         Duotone.faFilePlus,
         Duotone.faTypewriter,
         Duotone.faSave,
         Duotone.faDollyFlatbedAlt,
         Duotone.faPen,
         Duotone.faPhonePlus,
         Duotone.faLayerPlus,
         Duotone.faUser,
         Duotone.faPlusSquare
      );
   };
}

export default new IconProvider();
